/**
 * Tracks errors already forwarded to Sentry by React 19's `onCaughtError`
 * (in entry.client.tsx) during the current root's lifetime.
 *
 * `onCaughtError` fires synchronously in the React commit phase, before any
 * `useEffect` callbacks run. By marking the error here first, ErrorPage can
 * detect the duplicate and skip its own `captureException` call.
 *
 * WeakSet is chosen so GC of resolved errors is unobstructed and because
 * it rejects primitives — only object-typed errors need deduplication.
 */
export const reportedErrors = new WeakSet<object>()
